var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"no-body":""}},[_c('div',[(_vm.hasHeader)?_c('b-card-header',[_vm._t("pageHeader")],2):_vm._e(),_c('b-card-body',[_vm._t("pageBody")],2)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }